export enum AOSRouteDirection{
    SoftwareApp,
    Freeflex
}